<template>
    <catalog-layout id="checkout-page" class="h-100">
        <div class="container">
            <checkout-thanks-header :entry="entry" :subscription="subscription"
                :is-loading="isLoading"></checkout-thanks-header>

            <checkout-thanks-timeline></checkout-thanks-timeline>
        </div>
    </catalog-layout>
</template>

<script>
import CatalogLayout from '../../layouts/CatalogLayout.vue'
import { BContainer } from "bootstrap-vue";
import CheckoutThanksHeader from "../../components/molecules/CheckoutThanksHeader.vue";
import CheckoutThanksTimeline from "../../components/molecules/CheckoutThanksTimeline.vue";

export default {
    name: 'CheckoutThanks',
    components: {
        CheckoutThanksTimeline,
        CheckoutThanksHeader,
        CatalogLayout,
        BContainer,
    },
    data() {
        return {
            isLoading: true,
            isBroken: false,
            identifier: null,
            productApiUrl: null,
            entry: null,
            subscription: null,
            user: null
        }
    },
    methods: {
        getProductApiUrl() {
            return `/api/v1/catalog/vehicle/${this.subscription.vehicle_uuid}`
        },
        getIdentifier() {
            return this.$route.params.identifier ? this.$route.params.identifier : null
        },
        init() {
            this.isLoading = true
            this.identifier = this.getIdentifier()

            if (this.identifier === null) {
                this.isLoading = false
                this.isBroken = true
            } else {

                this.$axios.post('api/v1/dashboard/show_subscriptions_identifier', {
                    identifier: this.identifier
                }).then(response => {
                    this.subscription = response.data
                    this.productApiUrl = this.getProductApiUrl()

                    this.$axios.get(this.productApiUrl, {})
                        .then(response => {
                            this.entry = response.data.data
                            this.isLoading = false
                            this.googleAnalyticsPurchaseEvent()
                            this.deleteCheckoutDataFromLocalStorage()
                            if (this.user.user_verified !== 1 && this.$root.whitelabel.state.settings.stripe_identity === "1") {
                                this.initStripeIdentity()
                            }
                        })
                        .catch(error => {
                            this.error = error.response.data.message
                        })
                }).catch(error => {
                    this.error = error.response.data.message
                });
            }
        },
        getUser() {
            this.$axios.get('/api/v1/profile/get_profile_data', {})
                .then(response => {
                    this.user = response.data
                    this.isLoading = false
                }).catch(error => {
                    this.error = error.response.data.message
                });
        },
        initStripeIdentity() {
            if (this.user.user_verified !== 1) {
                this.$axios.get('/api/v1/checkout/init-stripe-identity')
                    .then(res => {
                        this.$root.stripe.stripe.verifyIdentity(res.data.secret)
                    })
                    .catch(err => {
                        this.error = err.response.data.message
                    })
            }
        },
        googleAnalyticsPurchaseEvent() {
            if (process.env.MIX_VUE_APP_ACTIVATE_GOOGLE_ANALYTICS && this.$gtag !== undefined) {
                const revenue = this.subscription.price_plan.price * this.subscription.price_plan.duration
                this.$gtag.event('purchase', {
                    currency: this.subscription.price_plan.currency.toUpperCase(),
                    value: revenue,
                    transaction_id: this.subscription.uuid,
                    items: [
                        {
                            item_id: this.entry.id,
                            item_name: this.entry.model.title,
                            item_brand: this.entry.brand.title,
                            item_category: this.entry.category.title,
                            subsidiary_id: this.$root.whitelabel.sub_id(),
                            price: this.subscription.price_plan.price,
                            mileage: this.subscription.price_plan.mileage,
                            duration: this.subscription.price_plan.duration
                        }
                    ]
                })
            }
        },
        deleteCheckoutDataFromLocalStorage() {
            localStorage.removeItem('selectedDuration')
            localStorage.removeItem('selectedMileage')
            localStorage.removeItem('selectedProduct')
        }
    },
    mounted() {
        this.getUser()
        this.init()
    },
    head: {
        title: function () {
            return {
                inner: this.$root.whitelabel.state.settings.meta_title,
                complement: this.$t('meta.checkoutThanks.title')
            }
        },
        meta: function () {
            return [
                { name: 'description', content: this.$t('meta.checkoutThanks.description') }
            ]
        }
    }
}
</script>
